// extracted by mini-css-extract-plugin
export var closeButton = "_oe-2";
export var closeButtonIcon = "_oe-3";
export var lightboxContent = "_oe-1";
export var lightboxOverlay = "_oe-0";